import { useMemo } from 'react';
import { ConfirmationDialogue, LockedFeatureDialogue } from 'vopay';
import { useHistory } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { useConfirmationDialogue } from './providers/ConfirmationDialogue.provider';
import { usePartnerLogin } from './providers/PartnerLogin.provider';
import { useLockedFeatureDialogue } from './providers/LockedFeatureDialogue.provider';
import styles from './App.module.scss';

const App = () => {
  const dialogueProps = useConfirmationDialogue();
  const history = useHistory();
  const { isAuthenticated } = usePartnerLogin();
  const { isLocked, updateIsLocked, lockedFeature } = useLockedFeatureDialogue();

  return (
    <div className={styles.app}>
      {useMemo(
        () => (
          <ConfirmationDialogue {...dialogueProps} />
        ),
        [dialogueProps],
      )}
      {useMemo(
        () => (
          <LockedFeatureDialogue
            lockedFeature={lockedFeature}
            isVisible={isLocked}
            cancel={() => updateIsLocked(false, '')}
            contactOutTeam={() => {
              history.push({
                pathname: '/tickets-create',
                state: { ticketSubject: `Enquiry about ${lockedFeature} feature` },
              });
              updateIsLocked(false, '');
            }}
          />
        ),
        [isLocked],
      )}

      {isAuthenticated === null ? null : isAuthenticated === false ? <Login /> : <Dashboard />}
    </div>
  );
};

export default App;
